import { render, staticRenderFns } from "./ShareRewardRecordList.vue?vue&type=template&id=f4fc297c&scoped=true"
import script from "./ShareRewardRecordList.vue?vue&type=script&lang=js"
export * from "./ShareRewardRecordList.vue?vue&type=script&lang=js"
import style0 from "./ShareRewardRecordList.vue?vue&type=style&index=0&id=f4fc297c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fc297c",
  null
  
)

export default component.exports